import React from "react";
import ScrollAnimation from "react-animate-on-scroll";
import {Container, Row, Col } from "react-bootstrap";
import "./HomeBookConsultation.scss";
import ReactMarkdown from "react-markdown"
import GetURL from '@Components/common/site/get-url';

import { inViewOptions } from '../../../Components/utils/animations';
import { motion } from "framer-motion";
import { InView } from "react-intersection-observer";

const containerVariants = {
    hidden: {
        opacity: 0
    },
    visible: {
        opacity: 1,
        transition: {
            staggerChildren: 0.4,
            ease: [0.33, 1, 0.68, 1],
            duration: 0.4
        }
    }
}

const HomeBookConsultation = (props) => {
    return (
        <InView {...inViewOptions}>
            {({ ref, inView }) => {
                return (
                    <motion.section
                        ref={ref}
                        initial="hidden"
                        animate={inView ? "visible" : "hidden"}
                        variants={containerVariants}
                    >
                        <React.Fragment>
                            <section className="home-book-consultation">
                                <ScrollAnimation animateIn='fadeInUp' animateOnce={true}>
                                    <Container>
                                        <Row>
                                            <Col lg={7}>
                                                <div className="block-head">
                                                    <ScrollAnimation animateOnce={true} animateIn='fadeIn'><h2>{props.Title}</h2></ScrollAnimation>
                                                    <ScrollAnimation animateOnce={true} animateIn='fadeIn'>
                                                        <ReactMarkdown source={props?.Content} allowDangerousHtml />
                                                    </ScrollAnimation>
                                                </div>
                                                <div className="btn-group-block btn-bg-dark d-none d-lg-flex">
                                                    {props.Cta_Label_1 && props.Cta_Url_1.Alias &&
                                                        <ScrollAnimation animateOnce={true} animateIn='fadeIn'>
                                                            <GetURL class={"btn btn-primary-bg"} label={props.Cta_Label_1} alias={props.Cta_Url_1.Alias} />
                                                        </ScrollAnimation>
                                                    }
                                                    {props.Cta_Label_2 && props.Cta_Url_1.Alias &&
                                                        <ScrollAnimation animateOnce={true} animateIn='fadeIn'>
                                                            <GetURL class={"btn btn-outline-bg"} label={props.Cta_Label_2} alias={props.Cta_Url_2.Alias} />
                                                        </ScrollAnimation>
                                                    }
                                                </div>
                                            </Col>
                                            <Col lg={5} className=" d-none d-lg-block">
                                                {/* <div className="person-detail person2">
                                                    <div className="person-info">
                                                        <div className="person-img">
                                                        <ScrollAnimation animateOnce={true} animateIn='fadeIn'>
                                                        <picture>
                                                            <source media="(min-width:992px)" srcSet={PersonImgDesktop2} />
                                                            <source media="(min-width:768px)" srcSet={PersonImgTablet2} />
                                                            <img src={PersonImgMobile2} alt="" />
                                                        </picture>
                                                        </ScrollAnimation>
                                                        </div>
                                                        <div className="person-content">
                                                        <ScrollAnimation animateOnce={true} animateIn='fadeIn'><p className="name">Catherine Witt</p></ScrollAnimation>
                                                        <ScrollAnimation animateOnce={true} animateIn='fadeIn'><p className="designation">Thame Senior Lettings</p></ScrollAnimation>
                                                        <ScrollAnimation animateOnce={true} animateIn='fadeIn'><p className="person-links"><Link href="mailto:" className="btn-text-link">Email</Link> / <Link href="#" className="btn-text-link">Book a Video Call</Link></p></ScrollAnimation>
                                                        </div>
                                                    </div>
                                                </div> */}
                                                </Col>
                                            </Row>
                                            {/* <Row className="d-lg-none">
                                                <Col lg={12}>
                                                    <div className="person-detail person2">
                                                        <div className="person-info">
                                                            <div className="person-img">
                                                            <ScrollAnimation animateOnce={true} animateIn='fadeIn'>   
                                                            <picture>
                                                                <source media="(min-width:992px)" srcSet={PersonImgDesktop2} />
                                                                <source media="(min-width:768px)" srcSet={PersonImgTablet2} />
                                                                <img src={PersonImgMobile2} alt="" />
                                                            </picture>
                                                            </ScrollAnimation>
                                                            </div>
                                                            <div className="person-content">
                                                            <ScrollAnimation animateOnce={true} animateIn='fadeIn'><p className="name">Catherine Witt</p></ScrollAnimation>
                                                            <ScrollAnimation animateOnce={true} animateIn='fadeIn'><p className="designation">Thame Senior Lettings</p></ScrollAnimation>
                                                            <ScrollAnimation animateOnce={true} animateIn='fadeIn'><p className="person-links"><Link href="mailto:" className="btn-text-link">Email</Link> / <Link href="#" className="btn-text-link">Book a Video Call</Link></p></ScrollAnimation>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row> */}
                                        <Row className="d-lg-none">
                                            <Col lg={5}>
                                                <div className="btn-group-block btn-bg-dark ">
                                                    {props.Cta_Label_1 && props.Cta_Url_1.Alias &&
                                                        <ScrollAnimation animateOnce={true} animateIn='fadeIn'>
                                                            <GetURL class={"btn btn-primary-bg"} label={props.Cta_Label_1} alias={props.Cta_Url_1.Alias} />
                                                        </ScrollAnimation>
                                                    }
                                                    {props.Cta_Label_2 && props.Cta_Url_1.Alias &&
                                                        <ScrollAnimation animateOnce={true} animateIn='fadeIn'>
                                                            <GetURL class={"btn btn-outline-bg"} label={props.Cta_Label_2} alias={props.Cta_Url_2.Alias} />
                                                        </ScrollAnimation>
                                                    }
                                                </div>
                                            </Col>
                                        </Row>
                                    </Container>
                                </ScrollAnimation>
                            </section>
                        </React.Fragment>
                    </motion.section>
                )
            }}
        </InView>
    )
}

export default HomeBookConsultation;